import React from 'react';
import PropTypes from 'prop-types';

import Style from './labelDetails.module.css';
import { Placeholder } from 'semantic-ui-react';

export function LabelDetailsContainer({ className = '', children = null }) {
    return <div className={`${Style['label-details__container']} ${className}`}>{children}</div>;
}

LabelDetailsContainer.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node
};

export default function LabelDetails({ className = '', title = '', children = null, loading = false }) {
    return (
        <div className={`${Style['label-details']} ${className}`}>
            <span className={`${Style['label-details__title']}`}>{title}</span>
            {loading ? (
                <span className={`${Style['label-details__placeholder']}`}>
                    <Placeholder>
                        <Placeholder.Line />
                    </Placeholder>
                </span>
            ) : (
                children && <span className={`${Style['label-details__children']}`}>{children}</span>
            )}
        </div>
    );
}

LabelDetails.propTypes = {
    title: PropTypes.node,
    className: PropTypes.string,
    children: PropTypes.node,
    loading: PropTypes.bool
};

LabelDetails.Container = LabelDetailsContainer;
